import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePatientAuth } from '../../contexts/PatientAuthContext';
import './PatientDashboard.css';

export default function PatientDashboard() {
  const navigate = useNavigate();
  const { user, loading } = usePatientAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8fafc'
      }}>
        <div style={{
          textAlign: 'center'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e2e8f0',
            borderTop: '3px solid #10b981',
            borderRadius: '50%',
            margin: '0 auto 12px',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ color: '#64748b' }}>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/patient/logout', {
        method: 'POST',
        credentials: 'include'
      });
      navigate('/patient/login');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <div className="patient-dashboard">
      <div className="dashboard-header">
        <div className="header-left">
          <h1>📱 Patient Dashboard</h1>
          {user && <p>Welcome, {user.name || 'Patient'}</p>}
        </div>
        <div className="header-right">
          <div className="user-avatar">
            {user?.name ? user.name[0].toUpperCase() : 'P'}
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      <div className="dashboard-content">
        <h2>My Documents</h2>

        <div className="folders-grid">
          <div 
            className="folder-card"
            onClick={() => navigate('/patient/lab-reports')}
          >
            <div className="folder-icon">📋</div>
            <div className="folder-info">
              <h3>Lab Reports</h3>
              <p>Upload test reports from camera or file</p>
            </div>
            <div className="folder-action">
              <button className="folder-btn">
                + Upload Report
              </button>
            </div>
          </div>

          <div 
            className="folder-card"
            onClick={() => navigate('/patient/prescriptions')}
          >
            <div className="folder-icon">💊</div>
            <div className="folder-info">
              <h3>Prescriptions</h3>
              <p>Medicines prescribed by your doctor</p>
              {user?.prescriptionCount > 0 && (
                <span className="count-badge">{user.prescriptionCount} prescription{user.prescriptionCount !== 1 ? 's' : ''}</span>
              )}
            </div>
            <div className="folder-action">
              <button className="folder-btn">
                View Prescriptions
              </button>
            </div>
          </div>
        </div>

        <div className="info-banner">
          <p>
            <strong>✨ Auto-Sync:</strong> Prescriptions from your doctor and lab reports are automatically synced to this dashboard. No manual action needed!
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
